import {
  Component,
  OnInit,
  Inject,
  Injector,
  ViewChild,
  Input,
  Output,
} from "@angular/core";
import { InvoiceCashDeskService } from "../../../services/invoice-cash-desk/invoice-cash-desk.service";
import { ActivatedRoute } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MenuService } from "../../../services/menu.service";
import { CashDeskUserOpen } from "../../../model/cash-desk-user-open";
import { InvoiceCashDesk } from "../../../model/invoice-cash-desk";
import { InvoiceCashDeskControlComponent } from "../../controls/invoice-cash-desk/invoice-cash-desk-edit/invoice-cash-desk-edit-control.component";
import { ConfirmDialogService } from "../../../services/confirm-dialog.service";
import { EventEmitter } from "@angular/core";
import { PatientService } from "src/app/services/patient.service";
import { PaymentGatewayService } from "src/app/services/payment-gateway/payment-gateway.service";
import { StatusPaymentGateway } from "src/app/model/payment-gateway/status-payment-gateway";

@Component({
  selector: "invoice-cash-desk-edit",
  templateUrl: "./invoice-cash-desk-edit.component.html",
  styleUrls: ["./invoice-cash-desk-edit.component.css"],
})
export class InvoiceCashDeskEditComponent implements OnInit {
  form: FormGroup;
  loading: boolean;
  loadingAction: boolean;
  generated: boolean;
  invoiceId?: number;
  cashDeskUserOpen: CashDeskUserOpen;
  transactionId: string | null = null;
  operationId : string | null = null;

  @Input() medicalappointmentid: number;
  @Input() atention: string;
  @Input() cashdeskinvoiceid: number;
  @Input() noClose: boolean = false;

  @ViewChild("invoiceCaskDeskEditControl", { static: false })
  invoiceCaskDeskEditControl: InvoiceCashDeskControlComponent;
  @Output() onClose = new EventEmitter();

  constructor(
    private invoiceCashDeskService: InvoiceCashDeskService,
    private paymentGatewayService: PaymentGatewayService,
    private formBuilder: FormBuilder,
    private menuService: MenuService,
    private notificationToastService: NotificationToastService,
    private confirmDialogService: ConfirmDialogService,
    private route: ActivatedRoute,
    private patientService: PatientService,
  ) {
    this.menuService.setMenuTitle("Cobranza", "Paciente");
    this.form = this.formBuilder.group({
      InvoiceCashDesk: [null],
    });
  }

  close(): void {
    this.onClose.emit();
  }

  async generate() {

    if (this.invoiceCaskDeskEditControl.isValid) {
      const invoiceCashDesk = <InvoiceCashDesk>(
        this.form.getRawValue().InvoiceCashDesk
      );
      const invoiceNumberBookPoint =
        await this.invoiceCashDeskService.getNextNumber(
          invoiceCashDesk.CashDeskInvoicePointId,
          invoiceCashDesk.InvoiceLabelType.Id,
        );

      this.confirmDialogService
        .confirm(
          "Cobranza",
          // "Se generará la factura: " +
          //   invoiceNumberBookPoint.Number +
          "Punto de venta: " + invoiceCashDesk.InvoicePoint.Name,
          "Aceptar",
          "Cancelar",
        )
        .subscribe(async (result) => {
          if (result) {
            try {
              this.loadingAction = true;

              console.log(invoiceCashDesk);


              if (
                invoiceCashDesk.InvoiceCashDeskPaymentQrLink &&
                invoiceCashDesk.InvoiceCashDeskPaymentQrLink.VirtualWalletFilter &&
                invoiceCashDesk.InvoiceCashDeskPaymentQrLink.VirtualWalletFilter
                  .RequiredIntegration &&
                !this.transactionId
              ) {
                this.transactionId = await this.paymentGatewayService.process(
                  this.cashDeskUserOpen.CashDesk.Id,
                  invoiceCashDesk.InvoiceCashDeskPaymentQrLink.PaymentAmount,
                  invoiceCashDesk.VirtualWalletOriginalAmount,
                  invoiceCashDesk.VirtualWalletTransactionId,
                );

                invoiceCashDesk.InvoiceCashDeskPaymentQrLink.VirtualWalletTransactionId =
                  this.transactionId;



                await this.waitForPaymentResult();


                invoiceCashDesk.InvoiceCashDeskPaymentQrLink.TranseferNumber = this.operationId ? this.operationId : "No disponible";

                this.invoiceCaskDeskEditControl.setQrLinkTransferNumber(this.operationId ? this.operationId : "No disponible");

                this.invoiceCaskDeskEditControl.setInvoiceCashDeskPaymentQrLink(
                  invoiceCashDesk.InvoiceCashDeskPaymentQrLink,
                );

                this.invoiceId =
                  await this.invoiceCashDeskService.createInvoiceCash(
                    invoiceCashDesk,
                  );
              } else {
                this.invoiceId =
                  await this.invoiceCashDeskService.createInvoiceCash(
                    invoiceCashDesk,
                  );
              }
              this.generated = true;
            } catch (err) {
              console.error(err);
              this.notificationToastService.error(
                JSON.stringify(err.error),
                "Cobranza",
              );
            } finally {
              this.loadingAction = false;
            }
          }
        });
    }
  }

  private sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  private async waitForPaymentResult(timeoutMs = 240000): Promise<void> {
    const start = Date.now();

    while (true && this.transactionId) {

        const result = await this.paymentGatewayService.getStatus(
          this.transactionId,
        );

        this.operationId = result.OperationId;

        if (result.Processed) {
          return;
        }

        if (result.Failed) {
           this.transactionId = null;

             this.notificationToastService.error(
               result.Observation,
                "Cobranza",
              );


          throw new Error(result.Observation);


        }

        if (Date.now() - start > timeoutMs) {

            this.notificationToastService.error(
              "Tiempo de espera agotado",
                "Cobranza",
              );

          throw new Error("Tiempo de espera agotado");
        }

        await this.sleep(3000);

    }
  }

  async ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async (params) => {
      try {
        this.atention = this.atention ? this.atention : params["Atention"];
        this.medicalappointmentid =
          this.medicalappointmentid && this.medicalappointmentid > 0
            ? this.medicalappointmentid
            : params["MedicalAppointmentId"];
        this.cashdeskinvoiceid =
          this.cashdeskinvoiceid && this.cashdeskinvoiceid > 0
            ? this.cashdeskinvoiceid
            : params["CashDeskInvoiceId"];
        if (!this.cashdeskinvoiceid) {
          this.cashdeskinvoiceid = params["Id"];
        }
        const invoiceCashDesk =
          await this.invoiceCashDeskService.getInvoiceCashDesk(
            this.medicalappointmentid,
            this.cashdeskinvoiceid,
            this.atention,
          );

        this.cashDeskUserOpen =
          await this.invoiceCashDeskService.getCashDeskUserOpen(
            true,
            true,
            invoiceCashDesk.EquipmentId,
            invoiceCashDesk.Service ? invoiceCashDesk.Service.Id : null,
            invoiceCashDesk.InvoicePoint
              ? invoiceCashDesk.InvoicePoint.Id
              : null,
          );

        if (this.cashDeskUserOpen) {
          this.form.patchValue({
            InvoiceCashDesk: invoiceCashDesk,
          });
        } else {
          this.notificationToastService.error(
            "No posee una caja asignada",
            "Cobranza",
          );
        }
      } catch (err) {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Cobranza",
        );
      } finally {
        this.loading = false;
      }
    });
  }
}
function timer(arg0: number, arg1: number) {
  throw new Error("Function not implemented.");
}

function switchMap(arg0: () => Promise<StatusPaymentGateway>): any {
  throw new Error("Function not implemented.");
}
